<div class="font-bold">{{ name }}
    <template v-if="identifier"> - {{ identifier }}</template>
</div>
<div class="font-bold" v-if="vatNumber">BTW {{ vatNumber }} </div>
